import {useEffect, useState, useRef} from "react";
import {useSessionActions} from "../../shared-services/redux-tiny";
import axios from "axios";
import apiEndpoints from "../shared/apiEndpoints";
import AngularIntegration from "../../angular-integration";

const {$on} = AngularIntegration;

const contextEndpoint = `${apiEndpoints.frontend}/session_context.json`;
const useSessionContext = () => {
  const {setSessionContext} = useSessionActions();
  const [loading, setLoading] = useState(false);
  const contextRef = useRef(false);

  const triggerLoad = () => {
    if (!loading) setLoading(true);
  };

  const loadSessionContext = () => {
    axios.get(contextEndpoint).then(response => {
      setSessionContext(response?.data || []);
    }).catch(error => {
      console.error("Error loading session state", {error});
    }).finally(() => {
      if (contextRef?.current) setLoading(false);
    });
  };

  useEffect(() => {
    if (loading) loadSessionContext();
  }, [loading]);

  useEffect(() => {
    triggerLoad();
    contextRef.current = true;

    const eventHandlers = {};

    $on("user:authenticated", (event, response) => {
      if (contextRef.current) triggerLoad();
    }).then(handler => {
      eventHandlers["user:authenticated"] = handler;
    });

    $on("zipcode:changed", (event, response) => {
      if (contextRef.current) triggerLoad();
    }).then(handler => {
      eventHandlers["zipcode:changed"] = handler;
    });

    return () => {
      contextRef.current = false;
      Object.keys(eventHandlers).forEach(key => eventHandlers[key]());
    };
  }, []);
};

export default useSessionContext;
